import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class K3OverridesService {

  constructor(private http: HttpClient) { }

  /**
   * Save/initiate K3 Overrides Sync process
   * Original action_code: 'vtzgh4'
   */
  saveK3Sync(
    baseUrl: string,
    params: any,
    globalParams: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = baseUrl + '/saveJsonObject';

    let mergedParams = _.merge({}, globalParams || {}, filterParams || {}, params);
    mergedParams.action_code = params.action_code || 'vtzgh4';
    mergedParams.sso_id = params.sso_id;
    mergedParams.tax_year = params.tax_year;
    mergedParams.scenario = params.scenario;
    mergedParams.jcd_key = params.jcd_key;
    mergedParams.p_form = params.p_form;
    mergedParams.p_filer_key = params.p_filer_key;
    mergedParams.p_flag = params.p_flag;
    mergedParams.p_filer_label = params.p_filer_label;
    mergedParams.scenarioCode = params.scenarioCode || mergedParams.scenarioCode || 'RAF';
    mergedParams.is_issue_key_enabled = params.is_issue_key_enabled || mergedParams.is_issue_key_enabled || 'N';
    mergedParams.checkLockedbj = params.checkLockedbj;

    const urlEncoded = new URLSearchParams();
    Object.keys(mergedParams).forEach(key => {
      if (mergedParams[key] !== undefined && mergedParams[key] !== null) {
        urlEncoded.set(key, mergedParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
